import React, { Component } from "react";
import { SideMenu } from "./SideMenu";
import CartContext from "./CartContext";
import { CategoryAddOrEditModal } from "./CategoryAddOrEditModal";
import { BsFillPencilFill } from "react-icons/bs";
import { BiSave, BiRefresh } from "react-icons/bi";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import Switch from "react-switch";
import TimePicker from "react-time-picker";
import {
  Nav,
  Table,
  OverlayTrigger,
  Tooltip,
  Navbar,
  Button,
  ButtonToolbar,
  Form,
  Accordion,
  Card,
  Row,
  Col,
} from "react-bootstrap";

export class Category extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      addModalShow: false,
      reload: true,
      mainCategories: "",
      subCategories: "",
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      isMobile: false,
    };
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    this.setState({ mainCategories: this.context.mainCategories });
    this.setState({ subCategories: this.context.subCategories });
    window.scrollTo(0, 0);
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    const isMobile = window.innerWidth < 768; // md breakpoint
    if (isMobile !== this.state.isMobile) this.setState({ isMobile });
  }

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });
  CloseMessagBoxCallback = () => this.setState({ msgboxOpen: false });

  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {});
  };

  OnRefreshButtonClick = () => {
    this.setState({ mainCategories: [] }, () => {
      this.setState({ subCategories: [] }, () => {
        this.setState({ mainCategories: this.context.mainCategories });
        this.setState({ subCategories: this.context.subCategories });
        this.setState({ reload: false }, () => {
          this.setState({ reload: true });
        });
      });
    });
  };

  OnDeleted = () => {
    // placeholder (kept)
  };

  OnUpdated = () => {
    // placeholder (kept)
  };

  ShowMessagBox = (title, message) => {
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  };

  render() {
    return (
      <div className="Container-fluid p-0 ">
        {this.state.msgboxOpen && (
          <MessageBox
            open={this.state.msgboxOpen}
            title={this.state.msgboxTitle}
            message={this.state.msgboxMessage}
            callback={this.CloseMessagBoxCallback}
          />
        )}

        <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
          <h3>
            <b>Category Management</b>
          </h3>
          <Navbar.Collapse className="justify-content-end mx-0 ">
            <Nav>
              <ButtonToolbar className="text-end align-middle">
                <Button
                  className="mainthemecolor"
                  onClick={() => this.setState({ addModalShow: true })}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    fill="currentColor"
                    className="bi bi-plus"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                  </svg>
                  Add Category
                </Button>
                &nbsp;
                <Button
                  className="mainthemecolor"
                  onClick={() => this.OnRefreshButtonClick()}
                >
                  <BiRefresh size="26" />
                  Refresh
                </Button>
                &nbsp;
                {this.state.addModalShow && (
                  <CategoryAddOrEditModal
                    show={this.state.addModalShow}
                    onHide={this.addModalClose}
                    storeId={this.context.storeId}
                    ModalType="Add"
                  />
                )}
              </ButtonToolbar>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <div className="purposestyle">
          <b>Purpose:</b> This module allows you to manage Main Categories and
          Subcategories of products. Each product is linked to a specific
          Subcategory, which in turn belongs to a Main Category. ⚠️ Important:
          Deleting a Main Category will also permanently delete all its
          associated Subcategories and Products.
        </div>

        {/* Desktop table view (md and up) */}
        <div className="Container-fluid mx-0 py-0 d-none d-md-block">
          <Table className="">
            <thead>
              <tr className="text-center text-dark bg-light">
                <th className="border py-0 ">
                  <h5>
                    <b>Main Category</b>
                  </h5>
                </th>
                <th className="border">
                  <h5>
                    <b>Sub Category</b>
                  </h5>
                </th>
                <th className="border"></th>
              </tr>
            </thead>
            <tbody className="text-primary "></tbody>
            {this.state.mainCategories !== "" &&
              this.state.mainCategories.map((maincategory, i) =>
                this.state.reload === true ? (
                  <EditCategoryInline
                    key={maincategory.id}
                    index={i}
                    maincategory={maincategory}
                    storeId={this.context.storeId}
                    subCategories={this.state.subCategories.filter(
                      (e) => e.mainCategoryId == maincategory.id
                    )}
                    OnDeleted={this.OnDeleted}
                    OnUpdated={this.OnUpdated}
                    isMobile={false}
                  />
                ) : (
                  ""
                )
              )}
          </Table>
        </div>

        {/* Mobile accordion view (sm and xs) */}
        <div className="d-block d-md-none px-2 pb-5">
          <Accordion defaultActiveKey="0">
            {this.state.mainCategories !== "" &&
              this.state.mainCategories.map((maincategory, i) =>
                this.state.reload === true ? (
                  <Card key={maincategory.id} className="mb-2">
                    <Accordion.Item eventKey={String(i)}>
                      <Accordion.Header>
                        <div className="w-100 d-flex justify-content-between align-items-center">
                          <div>
                            <strong>{maincategory.name}</strong>
                            <div style={{ fontSize: 12 }}>
                              {maincategory.description}
                            </div>
                          </div>
                          <div style={{ fontSize: 12, textAlign: "right" }}>
                            <div>
                              Sub:{" "}
                              {
                                this.state.subCategories.filter(
                                  (e) => e.mainCategoryId == maincategory.id
                                ).length
                              }
                            </div>
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <EditCategoryInline
                          index={i}
                          maincategory={maincategory}
                          storeId={this.context.storeId}
                          subCategories={this.state.subCategories.filter(
                            (e) => e.mainCategoryId == maincategory.id
                          )}
                          OnDeleted={this.OnDeleted}
                          OnUpdated={this.OnUpdated}
                          isMobile={true}
                        />
                      </Accordion.Body>
                    </Accordion.Item>
                  </Card>
                ) : (
                  ""
                )
              )}
          </Accordion>
        </div>
      </div>
    );
  }
}

/* -------------------------------------------------------------------------- */
/* ---------------------------- EditCategoryInline -------------------------- */
/* -------------------------------------------------------------------------- */

export class EditCategoryInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      maincategory: this.props.maincategory,
      subCategories: this.props.subCategories,
      addModalShow: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
    };
  }

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name.trim()) {
      case "name":
        this.state.maincategory.name = value;
        break;
      case "description":
        this.state.maincategory.description = value;
        break;
      case "hideMe":
        this.state.maincategory.hideMe = value;
        break;
      case "seqNo":
        this.state.maincategory.seqNo = value;
        break;
    }
    this.setState({ maincategory: this.state.maincategory });
  };

  handleSubCategoryControlChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.subCategories];
    list[index][name] = value;
    this.setState({ subCategories: list });
  };

  OnEditButtonClick = (e) => {
    this.setState({ addModalShow: true }, () => {});
  };
  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {});
  };

  ShowMessagBox = (title, message) => {
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  };
  CloseMessagBoxCallback = () => this.setState({ msgboxOpen: false });

  handleRemoveSubCategoryClick = (i) => {
    const list = [...this.state.subCategories];
    list.splice(i, 1);
    this.setState({ subCategories: list });
  };

  handleSubCategoryDeleteClick = (e, i) => {
    const list = [...this.state.subCategories];
    list.splice(i, 1);
    this.setState({ subCategories: list });
    this.ShowMessagBox(
      "Status",
      "This action was a Soft Delete! Next you have to Click `Save` to delete it from System."
    );
  };

  OnDeleteMainCategory = () => {
    this.ShowLoadSpinner();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/DeleteMainCategory/" +
        this.props.maincategory.id,
      requestOptions
    )
      .then((res) => {
        if (res.status != 200) {
          this.HideLoadSpinner();
          alert("not deleted");
          return;
        }
        this.context.getMainCategories();
        this.context.getSubCategories();
        this.context.GetAllProducts();
        this.HideLoadSpinner();
        this.ShowMessagBox(
          "Status",
          "Deleted Successfully. Click Refresh Button to see the changes!"
        );
        this.props.OnDeleted();
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("OnDelete Failed" + error);
      });
  };

  OnSave = () => {
    this.ShowLoadSpinner();
    this.state.maincategory.subCategories = this.state.subCategories;
    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(this.state.maincategory),
    };
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/UpdateMainCategory/" +
        this.state.maincategory.id,
      requestOptions
    )
      .then((res) => {
        if (res.status == 200) {
          this.context.getMainCategories();
          this.context.getSubCategories();
          this.context.GetAllProducts();
          this.HideLoadSpinner();
          console.log("Updated Successfully");
          this.ShowMessagBox(
            "Status",
            "Updated Successfully. Click Refresh Button to see the changes!"
          );
          this.props.OnUpdated();
          return;
        }
        this.HideLoadSpinner();
        alert("not updated");
        return;
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Failed" + error);
      });
  };

  handleMainCategoryHidemeChange = (checked) => {
    this.state.maincategory.hideMe = checked == false ? true : false;
    this.setState({ maincategory: this.state.maincategory });
  };
  handleSubCategoryHidemeChange = (e, index) => {
    const list = [...this.state.subCategories];
    list[index]["hideMe"] = !e;
    this.setState({ subCategories: list });
  };

  renderDesktopTable() {
    return (
      <tr className="align-top text-secondary text-center bg-white">
        {this.state.msgboxOpen && (
          <MessageBox
            open={this.state.msgboxOpen}
            title={this.state.msgboxTitle}
            message={this.state.msgboxMessage}
            callback={this.CloseMessagBoxCallback}
          />
        )}
        <td className="col-md-6 border-0 p-3">
          <Table className=" my-3 text-start bg-light ">
            <thead className="bg-light text-secondary text-center   ">
              <tr>
                <td width="5%">#</td>
                <td width="45%">Name</td>
                <td width="5%">Image</td>
                <td width="25%">Show Me</td>
                <td width="20%">Seq.No</td>
              </tr>
            </thead>
            <tbody size="" className="border">
              <tr style={{ fontSize: "12px" }}>
                <td className="align-top">{this.props.index + 1}</td>
                <td className="align-top">
                  <Form.Control
                    type="text"
                    name="name"
                    value={this.state.maincategory.name}
                    required
                    className="text-start align-middle bg-white"
                    onChange={(e) => this.handleInputChange(e)}
                  />
                </td>
                <td className="align-top">
                  <img
                    width="70px"
                    height="60px"
                    src={
                      this.context.store.storageBlobUrl +
                      this.context.store.storageBlobContainerName +
                      "/images/" +
                      this.state.maincategory.imgFileName +
                      this.context.store.storageSasToken
                    }
                    className="rounded-3"
                    alt="..."
                  />
                </td>
                <td className="align-top ">
                  <div className="text-center">
                    <Switch
                      height={20}
                      onChange={this.handleMainCategoryHidemeChange}
                      checked={!this.state.maincategory.hideMe}
                    />
                  </div>
                  {this.context.storeSettings.showEcommerceModule == true ||
                  this.context.storeSettings.showEcommerceModule ==
                    undefined ? (
                    <>
                      Open:
                      <TimePicker
                        amPmAriaLabel="Select AM/PM"
                        format="h:mm a"
                        onChange={(t) => {
                          this.state.maincategory.visibleStartTime = t;
                          this.setState({
                            maincategory: this.state.maincategory,
                          });
                        }}
                        value={
                          this.state.maincategory.visibleStartTime == undefined
                            ? "0:0"
                            : this.state.maincategory.visibleStartTime
                        }
                      />
                      <br />
                      Close:
                      <TimePicker
                        amPmAriaLabel="Select AM/PM"
                        format="h:mm a"
                        onChange={(t) => {
                          this.state.maincategory.visibleEndTime = t;
                          this.setState({
                            maincategory: this.state.maincategory,
                          });
                        }}
                        value={
                          this.state.maincategory.visibleEndTime == undefined
                            ? "23:59"
                            : this.state.maincategory.visibleEndTime
                        }
                      />
                    </>
                  ) : null}
                </td>
                <td className="align-top">
                  <Form.Control
                    type="number"
                    min={0}
                    name="seqNo"
                    value={this.state.maincategory.seqNo}
                    required
                    className="text-center align-middle bg-white"
                    onChange={(e) => this.handleInputChange(e)}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </td>

        <td className="col-md-5 p-3">
          <Table className="my-3 text-start  bg-light ">
            <thead className="bg-light text-secondary text-start ">
              <tr style={{ fontSize: "12px" }}>
                <th>#</th>
                <th>Name</th>
                <th>Image</th>
                <th>Show Me</th>
                <th>SeqNo</th>
                <th></th>
              </tr>
            </thead>
            <tbody className="border">
              {this.state.subCategories.map((subcategory, i) => (
                <tr
                  className="text-start"
                  style={{ fontSize: "12px" }}
                  key={subcategory.id || i}
                >
                  <td width="5%" className="text-start align-middle">
                    {i + 1}
                  </td>
                  <td width="35%" className="align-middle ">
                    <Form.Control
                      type="text"
                      name="name"
                      value={subcategory.name}
                      required
                      className="text-start"
                      onChange={(e) =>
                        this.handleSubCategoryControlChange(e, i)
                      }
                    />
                  </td>
                  <td width="10%" className="align-middle ">
                    <img
                      width="80px"
                      height="50px"
                      className="text-start rounded-3"
                      src={
                        this.context.store.storageBlobUrl +
                        this.context.store.storageBlobContainerName +
                        "/images/" +
                        subcategory.imgFileName +
                        this.context.store.storageSasToken
                      }
                      alt="..."
                    />
                  </td>
                  <td width="20%" className="align-middle ">
                    <Switch
                      height={20}
                      onChange={(e) => this.handleSubCategoryHidemeChange(e, i)}
                      checked={!subcategory.hideMe}
                    />
                  </td>
                  <td width="15%" className="align-middle">
                    <Form.Control
                      type="number"
                      min={0}
                      name="seqNo"
                      value={subcategory.seqNo}
                      required
                      size=""
                      className="text-start "
                      onChange={(e) =>
                        this.handleSubCategoryControlChange(e, i)
                      }
                    />
                  </td>
                  <td width="10%" className="align-middle ">
                    <OverlayTrigger
                      overlay={
                        <Tooltip>
                          Warning! This will Delete all products associated to
                          this sub-category as well
                        </Tooltip>
                      }
                    >
                      <Button
                        variant="outline-danger"
                        onClick={(e) => {
                          if (
                            window.confirm(
                              "Warning! This action will delete this Sub-Category and associated products. Are you sure you want to Delete? "
                            )
                          ) {
                            this.handleSubCategoryDeleteClick(e, i);
                          }
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-trash"
                          viewBox="0 0 16 16"
                        >
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                          <path
                            fillRule="evenodd"
                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                          />
                        </svg>
                      </Button>
                    </OverlayTrigger>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </td>

        <td className="col-md-1 text-end align-middle ">
          <div className="btn-group">
            <OverlayTrigger
              overlay={
                <Tooltip>
                  Save! Click this button after editing any fields on this Row.
                </Tooltip>
              }
            >
              <Button
                className="mx-1  rounded-circle"
                variant="success"
                onClick={(e) => {
                  this.OnSave(e);
                }}
              >
                <BiSave size="20" />
              </Button>
            </OverlayTrigger>

            {this.state.addModalShow && (
              <CategoryAddOrEditModal
                show={this.state.addModalShow}
                onHide={this.addModalClose}
                storeId={this.context.storeId}
                ModalType="Edit"
                maincategory={this.props.maincategory}
                subCategories={this.props.subCategories}
              />
            )}

            <OverlayTrigger
              overlay={
                <Tooltip>
                  Edit! Click this button if you wanted advanced edit operation
                  on this row in a Modal dialog window.
                </Tooltip>
              }
            >
              <Button
                className="mx-1 bg-warning rounded-circle"
                onClick={(e) => {
                  this.OnEditButtonClick(e);
                }}
              >
                <BsFillPencilFill size="20" />
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              overlay={
                <Tooltip>
                  Warning! This will delete this Main-Category, associated
                  Sub-categories and products.
                </Tooltip>
              }
            >
              <Button
                className="mx-1  bg-danger rounded-circle"
                onClick={(e) => {
                  if (
                    window.confirm(
                      "Warning! This action will delete this Main-category, subcategories and associated products. Are you sure you want to Delete?"
                    )
                  ) {
                    this.OnDeleteMainCategory(e);
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                  <path
                    fillRule="evenodd"
                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                  />
                </svg>
              </Button>
            </OverlayTrigger>
          </div>
        </td>
      </tr>
    );
  }

  renderMobileCard() {
    // Compact vertical layout suitable for small screens
    return (
      <div className="mb-2">
        {this.state.msgboxOpen && (
          <MessageBox
            open={this.state.msgboxOpen}
            title={this.state.msgboxTitle}
            message={this.state.msgboxMessage}
            callback={this.CloseMessagBoxCallback}
          />
        )}

        <div className="bg-light rounded-2 p-2 mb-2">
          <Table size="sm" responsive className="mb-2">
            <thead>
              <tr>
                <th>Main Cat.Name</th>
                <th>Desc</th>
                <th>SeqNo</th>
                <th>Image</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <Form.Control
                    type="text"
                    name="name"
                    value={this.state.maincategory.name}
                    required
                    className="mb-1"
                    onChange={(e) => this.handleInputChange(e)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="text"
                    name="description"
                    value={this.state.maincategory.description || ""}
                    className="mb-1"
                    onChange={(e) => this.handleInputChange(e)}
                  />
                </td>
                <td>
                  <Form.Control
                    value={this.state.maincategory.seqNo}
                    name="seqNo"
                    type="number"
                    size="sm"
                    onChange={(e) => this.handleInputChange(e)}
                  />
                </td>
                <td>
                  <img
                    style={{ maxWidth: "100%", maxHeight: 80 }}
                    src={
                      this.context.store.storageBlobUrl +
                      this.context.store.storageBlobContainerName +
                      "/images/" +
                      this.state.maincategory.imgFileName +
                      this.context.store.storageSasToken
                    }
                    alt=""
                    className="rounded-2"
                  />
                </td>
              </tr>
            </tbody>
          </Table>

          <div className="mt-2 d-flex justify-content-between align-items-center">
            <div>
              <small>Visible</small>
              <div>
                <Switch
                  height={20}
                  onChange={this.handleMainCategoryHidemeChange}
                  checked={!this.state.maincategory.hideMe}
                />
              </div>
            </div>

            <div className="text-end">
              <Button
                size="sm"
                className="me-1"
                variant="success"
                onClick={() => this.OnSave()}
              >
                Save
              </Button>
              <Button
                size="sm"
                className="me-1"
                variant="warning"
                onClick={() => this.OnEditButtonClick()}
              >
                Edit
              </Button>
              <Button
                size="sm"
                variant="danger"
                onClick={() => {
                  if (
                    window.confirm(
                      "Warning! This action will delete this Main-category, subcategories and associated products. Are you sure you want to Delete?"
                    )
                  ) {
                    this.OnDeleteMainCategory();
                  }
                }}
              >
                Delete
              </Button>
            </div>
          </div>

          {/* 🔧 Mount the modal for mobile too */}
          {this.state.addModalShow && (
            <CategoryAddOrEditModal
              show={this.state.addModalShow}
              onHide={this.addModalClose}
              storeId={this.context.storeId}
              ModalType="Edit"
              maincategory={this.props.maincategory}
              subCategories={this.props.subCategories}
            />
          )}
        </div>

        {/* Subcategories list (mobile stacked) */}
        <h5 className="mt-3">Subcategories</h5>
        <div>
          <Table size="sm" responsive>
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>SeqNo</th>
                <th>Show</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {this.state.subCategories.map((subcategory, i) => (
                <tr key={subcategory.id || i}>
                  <td style={{ width: 56 }}>
                    <img
                      style={{
                        width: "100%",
                        height: "30px",
                        objectFit: "cover",
                        borderRadius: 6,
                      }}
                      src={
                        this.context.store.storageBlobUrl +
                        this.context.store.storageBlobContainerName +
                        "/images/" +
                        subcategory.imgFileName +
                        this.context.store.storageSasToken
                      }
                      alt=""
                    />
                  </td>
                  <td>
                    <Form.Control
                      type="text"
                      name="name"
                      value={subcategory.name}
                      onChange={(e) =>
                        this.handleSubCategoryControlChange(e, i)
                      }
                    />
                  </td>
                  <td style={{ width: 90 }}>
                    <Form.Control
                      value={subcategory.seqNo}
                      name="seqNo"
                      type="number"
                      size="sm"
                      onChange={(e) =>
                        this.handleSubCategoryControlChange(e, i)
                      }
                    />
                  </td>
                  <td style={{ width: 70 }}>
                    <Switch
                      height={20}
                      onChange={(e) => this.handleSubCategoryHidemeChange(e, i)}
                      checked={!subcategory.hideMe}
                    />
                  </td>
                  <td style={{ width: 70 }}>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={(e) => {
                        if (
                          window.confirm(
                            "Warning! This action will delete this Sub-Category and associated products. Are you sure you want to Delete? "
                          )
                        ) {
                          this.handleSubCategoryDeleteClick(e, i);
                        }
                      }}
                    >
                      X
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }

  render() {
    // Respect isMobile passed from parent; default fallback false
    const isMobile = this.props.isMobile === true;
    return (
      <>
        {this.state.loadSpinnerOpen ? <LoadSpinner open="true" /> : null}
        {isMobile ? this.renderMobileCard() : this.renderDesktopTable()}
      </>
    );
  }
}
